import httpClient from "./httpClient";

const BASE_URL = "/reflastgreetings";

const createEndpoint = (action) => `${BASE_URL}/${action}`;

export const addLastGreeting = (payload) => httpClient.post(createEndpoint("create"), payload);

export const editLastGreeting = (payload) => httpClient.put(createEndpoint("update"), payload);

export const deleteLastGreeting = (id) => httpClient.delete(createEndpoint("delete"), { data: { Id: id } });

export const getLastGreetings = (personId) => httpClient.get(`${BASE_URL}/?personId=${personId}`);

export default {
  addLastGreeting,
  deleteLastGreeting,
  editLastGreeting,
  getLastGreetings,
};

// import httpClient from "./httpClient";

// export const addLastGreeting = async (payload) => {
//   const endpoint = "/reflastgreetings/create";
//   return httpClient.post(endpoint, payload);
// };

// export const editLastGreeting = async (payload) => {
//   const endpoint = "/reflastgreetings/update";
//   return httpClient.put(endpoint, payload);
// };

// export const deleteLastGreeting = async (payload) => {
//   const endpoint = "/reflastgreetings/delete";
//   return httpClient.delete(endpoint, { data: { Id: payload } });
// };

// export const getLastGreetings = async (payload) => {
//   const endpoint = `/reflastgreetings/?personId=${payload}`;
//   return httpClient.get(endpoint);
// };

// export default {
//   addLastGreeting,
//   deleteLastGreeting,
//   editLastGreeting,
//   getLastGreetings,
// };
